import {
  Box,
  BoxProps,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
} from '@chakra-ui/react';
import { useCallback, useState } from 'react';
import { useUser } from '../../../../../../../../../hooks/user';
import { MemberBookingTable } from '../../../../../../components/MemberBookingTable';
import { UserOnboardTable } from '../../../../../../components/UserOnboardTable';

export const GuestDetailsTabs = (props: BoxProps): JSX.Element => {
  const [tabIndex, setTabIndex] = useState(0);

  const { user: guest } = useUser();

  const handleTabChanges = useCallback((index: number) => {
    setTabIndex(index);
  }, []);

  return (
    <Box {...props}>
      <Tabs
        index={tabIndex}
        isLazy
        onChange={handleTabChanges}
        variant="enclosed-colored"
      >
        <TabList>
          {guest?.userAssignments[0]?.featureGroup.useExperienceLevel && (
            <Tab>Onboards</Tab>
          )}

          <Tab>Reservas</Tab>
        </TabList>

        <TabPanels mt="4">
          <TabPanel>
            <UserOnboardTable />
          </TabPanel>

          {guest?.userAssignments[0]?.featureGroup.useExperienceLevel && (
            <TabPanel>
              <MemberBookingTable />
            </TabPanel>
          )}
        </TabPanels>
      </Tabs>
    </Box>
  );
};
